import React, { useMemo } from "react";
import Bee from "./bee";
const beeStyles = {
  position: "relative",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: "calc(100vh - 30rem)",
  minHeight: "80rem",
};

const BeePage = ({
  onSave,
  baseTemplate,
  template,
  onStart,
  practiceId,
  setBeePluginAPI,
  onTogglePreview,
  mergeTags,
}) => {
  const beeConfig = useMemo(
    () => ({
      language: "en-US",
      autosave: true,
      uid: practiceId,
    }),
    [practiceId]
  );
  return (
    <Bee
      baseTemplate={baseTemplate}
      jsonTemplate={template}
      className="containerClassName"
      style={beeStyles}
      beeConfig={beeConfig}
      onSave={onSave}
      onStart={onStart}
      onSend={() => {}}
      onSaveAsTemplate={() => {}}
      onError={(errorMessage) => console.log(errorMessage)}
      setBeePluginAPI={setBeePluginAPI}
      onTogglePreview={onTogglePreview}
      mergeTags={mergeTags}
    />
  );
};
export default BeePage;
